<div class="rounded-sm shadow-md">
  @if (noClaims$ | async) {
    <pr-empty-state image="list" title="MOH claim requests" />
  } @else {
    <table
      *ngrxLet="displayedColumns$ as displayedColumns"
      mat-table
      matSort
      matSortActive="createdAt"
      matSortDirection="desc"
      class="w-full"
      [dataSource]="dataSource"
    >
      <ng-container matColumnDef="createdAt">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Created</th>
        <td *matCellDef="let data" mat-cell>
          {{ data.createdAt | moment | amDateFormat: dateFormat }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th *matHeaderCellDef mat-header-cell>Status</th>
        <td *matCellDef="let data" mat-cell>
          <pr-status-label
            class="w-16"
            [label]="data.status"
            [color]="data.status | map: getStatusColour"
            [dense]="true"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="claimType">
        <th *matHeaderCellDef mat-header-cell>Claim Type</th>
        <td *matCellDef="let data" mat-cell>
          {{ data.data.claimType | uppercase }}
        </td>
      </ng-container>

      <ng-container matColumnDef="reference">
        <th *matHeaderCellDef mat-header-cell>Reference</th>
        <td *matCellDef="let data" mat-cell>
          {{ data.data.claimUid }}
        </td>
      </ng-container>

      <ng-container matColumnDef="patient">
        <th *matHeaderCellDef mat-header-cell>Patient</th>
        <td *matCellDef="let data" mat-cell>
          <a
            class="text-blue-500"
            [routerLink]="data.patient | map: patientLink$ : this | async"
          >
            {{ data.patient.name }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="invoice">
        <th *matHeaderCellDef mat-header-cell>Invoice</th>
        <td *matCellDef="let data" mat-cell>
          <a
            class="text-blue-500"
            [routerLink]="
              data.data.invoiceRef | map: invoiceLink$ : this | async
            "
          >
            <button mat-icon-button>
              <mat-icon fontSet="material-symbols-outlined">article</mat-icon>
            </button>
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th *matHeaderCellDef mat-header-cell>Actions</th>
        <td *matCellDef="let data" mat-cell>
          <button
            mat-icon-button
            [matMenuTriggerFor]="moreMenu"
            [matMenuTriggerData]="{ claim: data }"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
      <tr *matNoDataRow class="mat-row">
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No MOH Claim Requests found.
        </td>
      </tr>
    </table>

    <mat-paginator
      #paginator
      showFirstLastButtons
      [length]="dataSource.data.length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
    />

    <mat-menu #moreMenu="matMenu">
      <ng-template let-claim="claim" matMenuContent>
        <button
          mat-menu-item
          [disabled]="(claim | map: claimSubmitted) === false"
          (click)="mohClaimsService.markAsApproved(claim)"
        >
          <mat-icon
            fontSet="material-symbols-outlined"
            class="!text-green-600 opacity-90"
          >
            check_circle
          </mat-icon>
          <span>Mark as Approved</span>
        </button>

        <button
          mat-menu-item
          [disabled]="(claim | map: claimSubmitted) === false"
          (click)="mohClaimsService.markAsDeclined(claim)"
        >
          <mat-icon
            fontSet="material-symbols-outlined"
            class="!text-warn-500 opacity-90"
          >
            cancel
          </mat-icon>
          <span>Mark as Declined</span>
        </button>

        <button
          mat-menu-item
          [disabled]="(claim | map: canCancel) === false"
          (click)="mohClaimsService.markAsCancelled(claim)"
        >
          <mat-icon
            fontSet="material-symbols-outlined"
            class="!text-warn-500 opacity-90"
          >
            block
          </mat-icon>
          <span>Cancel Claim</span>
        </button>

        <button mat-menu-item (click)="mohService.viewForms(claim)">
          <mat-icon fontSet="material-symbols-outlined" class="opacity-90">
            picture_as_pdf
          </mat-icon>
          <span>View Forms</span>
        </button>

        <button
          mat-menu-item
          [disabled]="(claim | map: claimInDraft) === false"
          (click)="mohClaimsService.signAndSubmitClaimRequest(claim)"
        >
          <mat-icon fontSet="material-symbols-outlined" class="opacity-90">
            edit
          </mat-icon>
          <span>Complete Request</span>
        </button>
      </ng-template>
    </mat-menu>
  }
</div>
